// Shared utilities for Dashboard emotion parsing and calculations

function parseTop5Map(str) {
  const out = { happy: 0, sad: 0, angry: 0, fear: 0, disgust: 0, surprise: 0 };
  if (!str) return out;
  String(str).split(',').forEach(seg => {
    const m = seg.trim().match(/([a-zA-Z]+)\s+(\d+(?:\.\d+)?)%/);
    if (m) {
      const key = m[1].toLowerCase();
      const val = parseFloat(m[2]);
      if (out.hasOwnProperty(key)) out[key] = val;
    }
  });
  return out;
}

export function buildDailyRows(records) {
  return records.map(r => {
    const dateStr = (r.report_date || r.created_at || '').slice(0, 10);
    const timeStr = r.created_at
      ? new Date(r.created_at).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })
      : '';
    const emotions = parseTop5Map(r.response?.RES?.top_5 || r.top_5);
    return { id: r.id, date: dateStr, time: timeStr, ...emotions };
  }).sort((a, b) => {
    if (a.date !== b.date) return b.date.localeCompare(a.date);
    return b.time.localeCompare(a.time);
  });
}

export function computeEmotionAnalytics(emotions, prevAggRes, parseTop5) {
  const toMap = (arr) => arr.reduce((m, e) => {
    m[e.raw || e.name.toLowerCase()] = e.value;
    return m;
  }, {});
  
  const curMap = toMap(emotions);
  const prevMap = prevAggRes ? toMap(parseTop5(prevAggRes.top_5)) : null;
  const dominant = emotions.reduce((a, b) => (a.value >= b.value ? a : b), emotions[0]);
  
  const stressCur = ((curMap.angry || 0) + (curMap.fear || 0) + (curMap.sad || 0)) / 3;
  const stressPrev = prevMap
    ? ((prevMap.angry || 0) + (prevMap.fear || 0) + (prevMap.sad || 0)) / 3
    : null;
  const stressDelta = (stressPrev != null) ? (stressCur - stressPrev) : null;
  
  const positive = (curMap.happy || 0) + (curMap.surprise || 0);
  const negative = (curMap.sad || 0) + (curMap.angry || 0) + (curMap.fear || 0) + (curMap.disgust || 0);
  const total = positive + negative || 1;
  const posPct = Math.min(100, Math.max(0, (positive / total) * 100));
  
  return { curMap, prevMap, dominant, stressCur, stressPrev, stressDelta, positive, negative, posPct };
}
